module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousEx
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": ""
    }
  }, [_c('h2', [_vm._v("Consol Master Merge")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("MAWB NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.consolModel.MAWBNumber),
      callback: function($$v) {
        _vm.$set(_vm.consolModel, "MAWBNumber", $$v)
      },
      expression: "consolModel.MAWBNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Consol Master Details House Bill Wise")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "shiper"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("HAWB No.")]), _vm._v(" "), _c('th', [_vm._v("HAWB Date")]), _vm._v(" "), _c('th', [_vm._v("Commodity Name")]), _vm._v(" "), _c('th', [_vm._v("HSN Code")]), _vm._v(" "), _c('th', [_vm._v("No. of Pkg.")]), _vm._v(" "), _c('th', [_vm._v("Total Gross Wgt.")]), _vm._v(" "), _c('th', [_vm._v("Total Volume Wgt.")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.cansolMasterMergeTable), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.HAWBNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item1.HAWBDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.itemName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.hsnCode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.noOfPackage))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cargoGrossWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.cargoVolumeWeight))])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-top": "1px solid #000",
      "font-size": "16px"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "right",
      "padding-right": "5%"
    },
    attrs: {
      "colspan": "7"
    }
  }, [_c('b', [_vm._v("Total Cargo Weight")])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.consolModel.totalcargoGrossWeight))])]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(_vm.consolModel.totalcargoVolumeWeight))])])])], 2)])])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargaeable Volume Wgt By System")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.consolModel.totalchargeVolWgtSys),
      callback: function($$v) {
        _vm.$set(_vm.consolModel, "totalchargeVolWgtSys", $$v)
      },
      expression: "consolModel.totalchargeVolWgtSys"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chargaeable Volume Wgt By Airline")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.consolModel.totalchargeVolWgtAir),
      callback: function($$v) {
        _vm.$set(_vm.consolModel, "totalchargeVolWgtAir", $$v)
      },
      expression: "consolModel.totalchargeVolWgtAir"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Final Chargaeable/Billable Weight")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.consolModel.totalfinalChargableWeight),
      callback: function($$v) {
        _vm.$set(_vm.consolModel, "totalfinalChargableWeight", $$v)
      },
      expression: "consolModel.totalfinalChargableWeight"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-286ece3a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/airFreight/cansolMasterMerge.vue
// module id = 2478
// module chunks = 0